// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Y3HzH","containerInput":"style_containerInput__15S2w","clip":"style_clip__2TMcK","input":"style_input__2eacM","uploader":"style_uploader__16aBa"};